<template>
  <div class="bucket-container">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">

          <div class="input-group input-group-sm pull-left">
            <span class="input-group-addon">{{ name }}</span>
            <input name="minVal" type="number" placeholder="Min. %" min="0" max="100"
                   :ariaLabel="ariaLabel[0]"
                   v-model="minVal" @change="bucketUpdated()"
                   :class="{'input': true, 'form-control': true, 'is-danger': errors.has('minVal') }"
                   v-validate="'between:0, 100|numeric|required'">


            <input name="maxVal" type="number" placeholder="Max. %" min="0" max="100"
                   :class="{'input': true, 'form-control': true, 'is-danger': errors.has('maxVal') }"
                   v-model="maxVal" @change="bucketUpdated()"
                   :ariaLabel="ariaLabel[0]"
                   v-validate="'between:0, 100|numeric|required'">

            <span class="input-group-addon">%</span>
          </div>

          <div class="btn-group btn-group-xs pull-right" role="group" aria-label="Add / Remove Bucket">
            <button type="button" class="btn btn-success" @click="addBucket()">
              <i class="fas fa-plus"></i>
            </button>
            <button type="button" class="btn btn-danger" @click="removeBucket()">
              <i class="fas fa-minus"></i>
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="row" v-if="errors.has('minVal') || errors.has('maxVal')">
      <div class="col-md-12">
        <p v-show="errors.has('minVal')" class="help is-danger">{{ errors.first('minVal') }}</p>
        <p v-show="errors.has('maxVal')" class="help is-danger">{{ errors.first('maxVal') }}</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'bucket',

  props: {
    id: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      minVal: parseInt(this.min),
      maxVal: parseInt(this.max)
    }
  },

  computed: {
    label () {
      return `Bucket ${parseInt(this.index)}`
    },

    ariaLabel () {
      return [
        `Bucket ${parseInt(this.index)} - Min. %`,
        `Bucket ${parseInt(this.index)} - Max. %`
      ]
    },

    chartLabel () {
      return `${parseInt(this.minVal)}% - ${parseInt(this.maxVal)}%`
    }
  },

  methods: {
    addBucket () {
      this.eventHub.$emit('bucketAdded', { min: parseInt(this.minVal), max: parseInt(this.maxVal) })
    },

    removeBucket () {
      this.eventHub.$emit('bucketRemoved', this.id)
    },

    bucketUpdated () {
      this.eventHub.$emit('bucketUpdated', {
        id: this.id,
        min: parseInt(this.minVal),
        max: parseInt(this.maxVal)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-group:not(:last-child) {
  width: 80%;
  margin-bottom: 10px;
}

.btn.btn-danger {
  background-color: RGBA(218, 102, 94, 0.8);
  border: 1px solid RGBA(218, 102, 94, 1);
}

.btn.btn-success {
  background-color: RGBA(139, 153, 105, 0.8);
  border: 1px solid RGBA(139, 153, 105, 1.00);
}

.help.is-danger {
  font-size: 0.8em;
  font-style: italic;
  font-weight: bold;
  color: rgba(218, 102, 94, 1.00);
  text-align: left;
}

input.is-danger {
  border: 1px solid rgba(218, 102, 94, 1.00);
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Bucket.vue